import script from "./MitiProjectsCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./MitiProjectsCarousel.vue?vue&type=script&setup=true&lang=js"

import "./MitiProjectsCarousel.vue?vue&type=style&index=0&id=a353ff6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a353ff6e"]])

export default __exports__